module.exports = __webpack_public_path__ + "img/arrow.5b434361.svg";